import { render, staticRenderFns } from "./GuideArticle.vue?vue&type=template&id=8741e3a2&scoped=true"
import script from "./GuideArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GuideArticle.vue?vue&type=style&index=0&id=8741e3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8741e3a2",
  null
  
)

export default component.exports